export default {
  // 报料详情接口
  getDiscloseMaterialInfo: '/amc/client/getDiscloseMaterialInfo',
}